import React from 'react';
import styles from './Loader.module.scss';

interface LoaderProps {
    fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ fullScreen = true }) => {
    if (fullScreen) {
        return (
            <div className={styles.loaderContainer}>
                <div className={styles.spinner} />
            </div>
        );
    }

    return <div className={styles.spinner} />;
};

export default Loader; 